module.exports = __webpack_public_path__ + "img/figure-26.7725291e.png";